import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["image", "buttonLabel", "view", "showAddBtn", "className", "autoFocus", "associatedUsers", "enableMentions", "personas"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import _noop from 'lodash/noop';
import _reduce from 'lodash/reduce';
import _isNil from 'lodash/isNil';
import _get from 'lodash/get';
import { Avatar, Button } from '@tekion/tmatter';
import { EMPTY_STRING, EMPTY_ARRAY, EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import AvatarDefault from '../../../atoms/Avatar';
import PropertyControlledComponent from '../../PropertyControlledComponent';
import NoteReader from '../Note.reader';
import { convertDisplayNamesToUserIds, translateUserMentioned, getTaggedUsersFromText } from '../Note.helpers';
import { VIEW_TYPE, DEFAULT_AVATAR_SIZE } from '../constants/note.general';
import NoteTextArea from './NoteTextArea';
import './noteInput.scss';
var NoteInput = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(NoteInput, _React$PureComponent);
  var _super = _createSuper(NoteInput);
  function NoteInput(props) {
    var _this;
    _classCallCheck(this, NoteInput);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "handleInputChange", function (event) {
      var noteInput = event.target.value;
      var validators = _this.props.validators;
      var validation = _reduce(_toConsumableArray(validators), function (acc, validatorFunction, index, arr) {
        if (!validatorFunction) {
          return acc;
        }
        var validationResponse = validatorFunction('', noteInput);
        if (!validationResponse.isValid) {
          acc = validationResponse;
          arr.length = 0;
        }
        return acc;
      }, {});
      _this.setState({
        noteInput: noteInput,
        validation: validation
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleUserSelect", function (_ref) {
      var original = _ref.original;
      var id = _get(original, 'id');
      if (id) _this.combinedUsers[id] = original;
    });
    _defineProperty(_assertThisInitialized(_this), "handleAddOrUpdate", function () {
      var _this$props = _this.props,
        addOrUpdateCallback = _this$props.handleAddOrUpdate,
        enableMentions = _this$props.enableMentions;
      var noteInput = _this.state.noteInput;
      if (NoteReader.isNoteValidText(noteInput)) return;
      var textEntered = enableMentions ? convertDisplayNamesToUserIds(noteInput, _this.combinedUsers) : noteInput;
      var taggedUsers = enableMentions ? getTaggedUsersFromText(textEntered) : [];
      addOrUpdateCallback(textEntered, taggedUsers);
      _this.combinedUsers = EMPTY_OBJECT;
      _this.setState({
        noteInput: EMPTY_STRING
      });
    });
    _defineProperty(_assertThisInitialized(_this), "renderAvatar", function () {
      var _this$props2 = _this.props,
        image = _this$props2.image,
        view = _this$props2.view,
        userName = _this$props2.userName;
      if (view === VIEW_TYPE.COMPACT) {
        return /*#__PURE__*/React.createElement(Avatar, {
          containerClassName: "note-editor__avatar",
          image: image,
          size: "small"
        });
      }
      return /*#__PURE__*/React.createElement(AvatarDefault, {
        containerClassName: "note-editor__avatar",
        size: DEFAULT_AVATAR_SIZE,
        image: image,
        name: userName,
        displayName: false
      });
    });
    var associatedUsers = _get(props, 'associatedUsers') || EMPTY_OBJECT;
    _this.state = {
      noteInput: EMPTY_STRING,
      validation: EMPTY_OBJECT
    };
    _this.combinedUsers = _objectSpread({}, associatedUsers);
    return _this;
  }
  _createClass(NoteInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var noteInput = this.props.note;
      this.setState({
        noteInput: noteInput
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        image = _this$props3.image,
        buttonLabel = _this$props3.buttonLabel,
        view = _this$props3.view,
        showAddBtn = _this$props3.showAddBtn,
        className = _this$props3.className,
        autoFocus = _this$props3.autoFocus,
        associatedUsers = _this$props3.associatedUsers,
        enableMentions = _this$props3.enableMentions,
        personas = _this$props3.personas,
        rest = _objectWithoutProperties(_this$props3, _excluded);
      var _this$state = this.state,
        noteInput = _this$state.noteInput,
        validation = _this$state.validation;
      var showAvatar = !_isNil(image);
      var text = enableMentions ? translateUserMentioned(noteInput, this.combinedUsers) : noteInput;
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "note-editor ".concat(className)
      }, showAvatar && this.renderAvatar(), /*#__PURE__*/React.createElement(NoteTextArea, _extends({
        autoFocus: autoFocus,
        className: view === VIEW_TYPE.DEFAULT ? cx('note-editor__textarea', _defineProperty({}, rest.isEditing, 'update')) : 'note-editor__textarea-full-width',
        placeholder: __('Add Note'),
        value: text,
        onChange: this.handleInputChange,
        onSelect: this.handleUserSelect,
        onKeyDown: this.handleAddOrUpdate,
        error: NoteReader.noteHasErrorMsg(validation),
        enableMentions: enableMentions,
        personas: personas
      }, rest)), /*#__PURE__*/React.createElement(PropertyControlledComponent, {
        controllerProperty: view === VIEW_TYPE.DEFAULT
      }, showAddBtn && /*#__PURE__*/React.createElement(Button, {
        disabled: NoteReader.isNoteValidText(noteInput) || NoteReader.noteHasErrorMsg(validation),
        className: "note-editor__add-button",
        onClick: this.handleAddOrUpdate
      }, __(buttonLabel)))));
    }
  }]);
  return NoteInput;
}(React.PureComponent);
_defineProperty(NoteInput, "propTypes", {
  note: PropTypes.string,
  image: PropTypes.string,
  buttonLabel: PropTypes.string,
  handleAddOrUpdate: PropTypes.func,
  showAddBtn: PropTypes.bool,
  view: PropTypes.string,
  validators: PropTypes.array,
  userName: PropTypes.string,
  className: PropTypes.string,
  autoFocus: PropTypes.bool,
  associatedUsers: PropTypes.object,
  enableMentions: PropTypes.bool,
  personas: PropTypes.array
});
_defineProperty(NoteInput, "defaultProps", {
  note: EMPTY_STRING,
  image: EMPTY_STRING,
  buttonLabel: 'Add',
  handleAddOrUpdate: _noop,
  showAddBtn: true,
  view: VIEW_TYPE.DEFAULT,
  validators: EMPTY_ARRAY,
  userName: '',
  className: '',
  autoFocus: true,
  associatedUsers: EMPTY_OBJECT,
  enableMentions: false,
  personas: EMPTY_ARRAY
});
export default NoteInput;